var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "bar-main",
      class: _vm.showEditPosition,
      on: { mousedown: _vm.showLabelInfo },
    },
    [
      _c("input", {
        ref: "files",
        attrs: { id: "input", type: "file", accept: "image/*", hidden: "" },
        on: {
          click: function (e) {
            e.target.value = ""
          },
          change: _vm.handleFileChange,
        },
      }),
      _vm.linkageAreaShow
        ? _c(
            "div",
            { staticStyle: { "margin-right": "-1px", width: "20px" } },
            [
              _c("el-checkbox", {
                attrs: { size: "medium" },
                model: {
                  value: _vm.linkageInfo.linkageActive,
                  callback: function ($$v) {
                    _vm.$set(_vm.linkageInfo, "linkageActive", $$v)
                  },
                  expression: "linkageInfo.linkageActive",
                },
              }),
              _vm.linkageInfo.linkageActive
                ? _c("linkage-field", { attrs: { element: _vm.element } })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.positionCheck("multiplexing") && _vm.showMultiplexingCheck
        ? _c(
            "div",
            {
              staticStyle: {
                "margin-right": "1px",
                width: "18px",
                "z-index": "5",
              },
            },
            [
              _c("el-checkbox", {
                attrs: { size: "medium" },
                on: { change: _vm.multiplexingCheck },
                model: {
                  value: _vm.multiplexingCheckModel,
                  callback: function ($$v) {
                    _vm.multiplexingCheckModel = $$v
                  },
                  expression: "multiplexingCheckModel",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.batchOptAreaShow
        ? _c(
            "div",
            {
              staticStyle: {
                "margin-right": "-1px",
                width: "20px",
                "z-index": "5",
              },
            },
            [
              _c("el-checkbox", {
                attrs: { size: "medium" },
                on: { change: _vm.batchOptChange },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.normalAreaShow
        ? _c(
            "div",
            [
              _c("span", { attrs: { title: _vm.$t("panel.edit") } }, [
                _vm.activeModel === "edit" &&
                _vm.curComponent &&
                _vm.editFilter.includes(_vm.curComponent.type)
                  ? _c("i", {
                      staticClass: "icon iconfont icon-edit",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.edit($event)
                        },
                      },
                    })
                  : _vm._e(),
              ]),
              _c("span", { attrs: { title: _vm.$t("panel.matrix") } }, [
                _vm.activeModel === "edit" && _vm.curComponent.auxiliaryMatrix
                  ? _c("i", {
                      staticClass: "icon iconfont icon-shujujuzhen",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.auxiliaryMatrixChange($event)
                        },
                      },
                    })
                  : _vm._e(),
              ]),
              _c("span", { attrs: { title: _vm.$t("panel.suspension") } }, [
                _vm.activeModel === "edit" && !_vm.curComponent.auxiliaryMatrix
                  ? _c("i", {
                      staticClass: "icon iconfont icon-xuanfuanniu",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.auxiliaryMatrixChange($event)
                        },
                      },
                    })
                  : _vm._e(),
              ]),
              _c("span", { attrs: { title: _vm.$t("panel.enlarge") } }, [
                _vm.enlargeShow
                  ? _c("i", {
                      staticClass: "icon iconfont icon-fangda",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.showViewDetails("enlarge")
                        },
                      },
                    })
                  : _vm._e(),
              ]),
              _c("span", { attrs: { title: _vm.$t("panel.details") } }, [
                _vm.detailsShow
                  ? _c("i", {
                      staticClass: "icon iconfont icon-chakan",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.showViewDetails("details")
                        },
                      },
                    })
                  : _vm._e(),
              ]),
              _vm.activeModel === "edit"
                ? _c(
                    "setting-menu",
                    {
                      staticStyle: { float: "right", height: "24px!important" },
                      on: {
                        amRemoveItem: _vm.amRemoveItem,
                        linkJumpSet: _vm.linkJumpSet,
                        boardSet: _vm.boardSet,
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          attrs: {
                            slot: "icon",
                            title: _vm.$t("panel.setting"),
                          },
                          slot: "icon",
                        },
                        [
                          _c("i", {
                            staticClass: "icon iconfont icon-shezhi",
                            staticStyle: { "margin-top": "2px", width: "16px" },
                          }),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _c("span", { attrs: { title: _vm.$t("panel.cancel_linkage") } }, [
                _vm.curComponent.type === "view" && _vm.existLinkage
                  ? _c("i", {
                      staticClass: "icon iconfont icon-quxiaoliandong",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.clearLinkage($event)
                        },
                      },
                    })
                  : _vm._e(),
              ]),
              _c("span", { attrs: { title: _vm.$t("panel.switch_picture") } }, [
                _vm.activeModel === "edit" &&
                _vm.curComponent &&
                _vm.curComponent.type === "picture-add"
                  ? _c("i", {
                      staticClass: "icon iconfont icon-genghuan",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.goFile($event)
                        },
                      },
                    })
                  : _vm._e(),
              ]),
              _vm.selectFieldShow
                ? _c(
                    "el-popover",
                    {
                      attrs: { width: "200", trigger: "click" },
                      on: { mousedown: _vm.fieldsAreaDown },
                    },
                    [
                      _c("fields-list", {
                        attrs: { fields: _vm.curFields, element: _vm.element },
                      }),
                      _c("i", {
                        staticClass: "icon iconfont icon-datasource-select",
                        staticStyle: {
                          "margin-left": "4px",
                          cursor: "pointer",
                          "font-size": "14px",
                        },
                        attrs: {
                          slot: "reference",
                          disabled: _vm.element.editing,
                          title: _vm.$t("panel.select_field"),
                        },
                        slot: "reference",
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c("span", { attrs: { title: _vm.$t("panel.jump") } }, [
                _vm.showJumpFlag
                  ? _c(
                      "a",
                      {
                        attrs: {
                          title: _vm.curComponent.hyperlinks.content,
                          target: _vm.curComponent.hyperlinks.openMode,
                          href: _vm.curComponent.hyperlinks.content,
                        },
                      },
                      [_c("i", { staticClass: "icon iconfont icon-com-jump" })]
                    )
                  : _vm._e(),
              ]),
              _vm.chart && _vm.showMapLayerController
                ? _c("map-layer-controller", {
                    attrs: {
                      chart: _vm.chart,
                      "series-id-map": _vm.seriesIdMap,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-css",
          attrs: {
            visible: _vm.linkJumpSetVisible,
            width: "900px",
            "show-close": true,
            "destroy-on-close": true,
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.linkJumpSetVisible = $event
            },
          },
        },
        [
          _vm.linkJumpSetVisible
            ? _c("link-jump-set", {
                attrs: { "view-id": _vm.linkJumpSetViewId },
                on: { closeJumpSetDialog: _vm.closeJumpSetDialog },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-css",
          attrs: {
            visible: _vm.boardSetVisible,
            width: "750px",
            top: "5vh",
            "close-on-click-modal": false,
            "show-close": false,
            "destroy-on-close": true,
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.boardSetVisible = $event
            },
          },
        },
        [
          _vm.boardSetVisible
            ? _c("background", {
                on: { backgroundSetClose: _vm.backgroundSetClose },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }